<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="租号" prop="rentNumber">
              <el-input
                v-model="queryForm.rentNumber"
                placeholder="请输入租号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="租号状态" prop="rentStatus">
              <el-select
                v-model="queryForm.rentStatus"
                clearable
                placeholder="请选择租号状态"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="submitQueryForm()"
                icon="el-icon-search"
              >
                查询</el-button
              >
              <el-button
                type="primary"
                size="small"
                plain
                @click="resetQueryForm()"
                icon="el-icon-refresh"
              >
                重置</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    
    <el-card>
        <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="releaseRentNum">发布租号
       </el-button>
       <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                ref="table"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="id" label="租号ID" width="180">
          <!--<template slot-scope="scope">
            <span>{{ getStrEndWithNumbers(scope.row.userId) }}</span>
          </template>-->
        </el-table-column>
        <el-table-column prop="rentNumbers" label="租号"/>
        <!-- <el-table-column prop="upBusinessUser" label="上级用户"/>
        <el-table-column prop="businessUser" label="业务员"/> -->
        <el-table-column prop="rentNumberPrice" label="价格"/>
        <el-table-column prop="rentStatus" label="状态"/>
        <el-table-column prop="createTime" label="添加时间"/>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-row style="margin-top: 5px;">
              <!-- <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="addRemarks(scope.$index, scope.row)">
                  备注
                </el-button>
              </el-col> -->
              <el-col :span="12">
                <el-button size="mini" type="primary" plain
                           @click="settingAccountInfo(scope.$index, scope.row)">
                  设置
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-button size="mini" type="primary" plain
                           @click="reviewAccountInfo(scope.$index, scope.row)">
                  查看
                </el-button>
              </el-col>
              <!-- <el-col :span="6">
                <el-button size="mini" type="primary" plain
                           @click="accountReviewCurrentRow(scope.$index, scope.row)" v-show="scope.row.plateformStatusStr != '审核通过'">
                  审核
                </el-button>
              </el-col> -->
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="租号数量：">
          <el-input v-model="dialogForm.rentNumbers" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="租号价格：">
          <el-input v-model="dialogForm.rentNumberPrice" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="租号规则：">
          <el-select v-model="dialogForm.rentRole" clearable size="mini">
            <el-option
                v-for="item in rentRoles"
                :key="item.id"
                :label="item.value"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitBuildRentNumber()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";
import MinxinScroll from "@/components/MinxinScroll";
import {buildRentNumbers, queryRentNumbers} from "../../api/b2cbusiness/b2c_admin"
export default {
  name: "RentNumberManage",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      queryForm: {},
      options: [
        {
            id: 1,
            value: "准备中"
        },
        {
            id: 2,
            value: "养号中"
        },
        {
            id: 3,
            value: "养号完成"
        },
        {
            id: 4,
            value: "商城下单"
        },
        {
            id: 5,
            value: "已完成"
        }
      ],
      rentRoles: [
        {
          id: 1,
          value: "中文账号"
        },
        {
          id: 2,
          value: "手机号"
        },
        {
          id: 3,
          value: "数字账号"
        }
      ],
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: "发布租号",
      dialogRefName: "dialogForm",
      dialogForm: {
      },
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    releaseRentNum(){
      this.dialogFormVisible = true
    },
    submitBuildRentNumber(){
      buildRentNumbers(this.dialogForm).then(res=>{
        if(res.success){
          console.log(res.data)
          this.dialogFormVisible = false;
          this.getData();
        }
      })
    },
    getData(){
      queryRentNumbers(this.queryForm, this.pagination).then(res => {
        if(res.success){
          this.tableData = res.data.records
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      })
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
